module.exports = __webpack_public_path__ + "static/img/Bachelor_010347.4baeb0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010347.jpg
// module id = 152
// module chunks = 0